var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationTriangleFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.003,
    height: 14.001,
    viewBox: "0 0 16.003 14.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "exclamation-triangle-fill_1_",
    "data-name": "exclamation-triangle-fill(1)",
    d: "M8.982,1.566a1.13,1.13,0,0,0-1.96,0L.165,13.233A1.167,1.167,0,0,0,1.145,15H14.858a1.167,1.167,0,0,0,.98-1.767ZM8,5a.9.9,0,0,1,.9.995L8.55,9.5a.552.552,0,0,1-1.1,0L7.1,5.995A.9.9,0,0,1,8,5Zm0,6a1,1,0,1,1-1,1A1,1,0,0,1,8,11Z",
    transform: "translate(0 -0.999)",
    fill: "#f2163e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangleFill);
export default __webpack_public_path__ + "static/media/exclamation-triangle-fill.d15ac05c.svg";
export { ForwardRef as ReactComponent };